module.exports = __webpack_public_path__ + "static/media/logo.9290bf5b.png";